import React from 'react'

export const CabinMediaDrawerArrowRight: React.FC<React.SVGProps<SVGSVGElement>> = ({
    width = 56,
    height = 56,
    ...rest
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <mask
            id="cabin-media-drawer-arrow-right-mask"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="56"
            height="56"
        >
            <rect width="56" height="56" transform="matrix(-1 0 0 1 56 0)" fill="#D9D9D9" />
        </mask>
        <g mask="url(#cabin-media-drawer-arrow-right-mask)">
            <rect x="8" y="8.01758" width="40" height="40" rx="20" fill="white" />
            <path
                d="M28.5258 34.6492C28.3799 34.8048 28.1977 34.8728 27.9789 34.8534C27.7602 34.8339 27.573 34.7464 27.4174 34.5909C27.2619 34.4353 27.1841 34.2474 27.1841 34.027C27.1841 33.8066 27.2619 33.6252 27.4174 33.4826L32.1424 28.8159H20.9424C20.748 28.8159 20.573 28.7374 20.4174 28.5805C20.2619 28.4236 20.1841 28.2292 20.1841 27.9972C20.1841 27.7652 20.2624 27.5714 20.4189 27.4159C20.5754 27.2603 20.7694 27.1826 21.0008 27.1826H32.1424L27.4174 22.4576C27.2619 22.3117 27.1938 22.1294 27.2133 21.9107C27.2327 21.6919 27.3202 21.5048 27.4758 21.3492C27.6313 21.1937 27.8193 21.1159 28.0397 21.1159C28.26 21.1159 28.4415 21.1937 28.5841 21.3492L33.9508 26.7742C34.3008 27.1242 34.4758 27.5326 34.4758 27.9992C34.4758 28.4659 34.3008 28.8742 33.9508 29.2242L28.5258 34.6492ZM27.9906 48.2992C30.7974 48.2992 33.4366 47.7666 35.9083 46.7014C38.3801 45.6362 40.5301 44.1905 42.3585 42.3644C44.1869 40.5383 45.6344 38.391 46.7009 35.9224C47.7675 33.4538 48.3008 30.8161 48.3008 28.0094C48.3008 25.2026 47.7682 22.5634 46.703 20.0917C45.6377 17.6199 44.1921 15.4699 42.366 13.6415C40.5399 11.8131 38.3926 10.3656 35.924 9.29907C33.4554 8.2325 30.8177 7.69922 28.0109 7.69922C25.2042 7.69922 22.5649 8.23182 20.0932 9.29703C17.6215 10.3623 15.4714 11.8079 13.6431 13.634C11.8147 15.4601 10.3672 17.6074 9.30063 20.076C8.23407 22.5446 7.70078 25.1823 7.70078 27.9891C7.70078 30.7958 8.23338 33.4351 9.29859 35.9068C10.3638 38.3785 11.8095 40.5286 13.6356 42.357C15.4617 44.1853 17.609 45.6328 20.0776 46.6994C22.5462 47.7659 25.1839 48.2992 27.9906 48.2992ZM28.0008 46.6659C22.8286 46.6659 18.4244 44.8478 14.7883 41.2117C11.1522 37.5756 9.33411 33.1714 9.33411 27.9992C9.33411 22.827 11.1522 18.4228 14.7883 14.7867C18.4244 11.1506 22.8286 9.33255 28.0008 9.33255C33.173 9.33255 37.5772 11.1506 41.2133 14.7867C44.8494 18.4228 46.6674 22.827 46.6674 27.9992C46.6674 33.1714 44.8494 37.5756 41.2133 41.2117C37.5772 44.8478 33.173 46.6659 28.0008 46.6659Z"
                fill="#1A1A1A"
            />
        </g>
    </svg>
)

export default CabinMediaDrawerArrowRight
